import React from 'react'
import Modal from '../Modal'

const TermsModal = ({ open, handleClose }) => {
  return (
    <Modal open={open} noButtons onCancel={handleClose}>
      <div>
        <div className="text-bold text-center mb-4 font-bold">Terms and Conditions</div>
        <div className="grid gap-4 text-gray-400">
          <h1 className="font-bold">BOOTVISION</h1>
          <h2 className="my-4 font-bold">User Agreement</h2>
          <p className="font-bold">Enactment Date 9/01/2021</p>
          <p>
            This Agreement (the “Agreement”) is between you (hereinafter “you” or “Customer”) and
            Risetek Global, LLC (“Risetek," “we,” “us,” or “our”) and applies to your use of the
            software application, including the Content (the “Application”).
          </p>
          <p>
            This Agreement includes the Terms and Conditions below, together with the Additional
            Terms. Please read all of these terms carefully before accepting this Agreement and
            using the Application.
          </p>
          <p>If you do not agree to this Agreement, do not install or use the Application.</p>
          <p>
            If you are under the age of 18 (or the age of majority where you live), you must get
            your parent or legal guardian to accept this Agreement.
          </p>

          <p>
            Our <a href="https://www.nintendo.com/privacy-policy/">Privacy Policy</a> explains how
            we use and protect your personal information when you use the Application. By using the
            Application you acknowledge that you have read our Privacy Policy.
          </p>

          <p className="font-bold">This Agreement</p>

          <p>
            NOTE: TO THE FULLEST EXTENT PERMITTED BY LAW, THIS AGREEMENT CONTAINS A BINDING
            INDIVIDUAL ARBITRATION AND CLASS ACTION WAIVER PROVISION IN SECTION 16 THAT AFFECTS YOUR
            RIGHTS UNDER THIS AGREEMENT AND WITH RESPECT TO ANY "CLAIM" (AS DEFINED IN SECTION 17)
            BETWEEN YOU AND RISETEK.
          </p>

          <ul>
            <ol>
              <li>
                <h3 className="my-4 font-bold">Definitions</h3>
                <p>
                  For the purposes of this Agreement, the following terms shall have the following
                  definitions:
                </p>
                <ul>
                  <li className="my-2">
                    "Additional Terms" means the terms we reference or link to within this
                    Agreement, including, without limitation, those set forth at the end of this
                    Agreement;
                  </li>
                  <li className="my-2">
                    "Content" collectively refers to all software (including, without limitation,
                    Digital Items), documentation, data, downloadable content, updates and upgrades
                    thereto, services, and other items that we make available to you through and in
                    connection with the Application;
                  </li>
                  <li className="my-2">
                    "Digital Items" means content (including, but not limited to, in-game currency)
                    you purchase or otherwise acquire for use in the Application through the
                    mechanisms we make available;
                  </li>
                  <li className="my-2">
                    "Linked Services" means the services (other than the Application) offered by
                    Risetek or its partners we make available for use with the Application,
                    including, without limitation, the Risetek Account Service and Third Party
                    Services;
                  </li>
                  <li className="my-2">
                    “Risetek Account” means the account created by a customer that is utilized with
                    the Risetek Account Service;
                  </li>
                  <li className="my-2">
                    "Risetek Account Service" means the services offered by Risetek or its partners
                    that are accessed through or offered in connection with a Risetek Account,
                    including, without limitation, Linked Services;
                  </li>
                  <li className="my-2">
                    “Third Party Service(s)” means the services, applications, software, content,
                    and data, including updates and upgrades thereto, offered by authorized third
                    parties that are made available in connection with the Application;
                  </li>
                </ul>
              </li>
              <li>
                <h3 className="my-4 font-bold">Creating a Risetek Account</h3>
                <p>
                  You may need to create a Risetek Account and link it to the Application to utilize
                  certain Application features. Please see Risetek’s website for information on how
                  to create and use a Risetek Account.
                </p>
              </li>
              <li>
                <h3 className="my-4 font-bold">Use of the Application</h3>
                <p>
                  3.1 You must comply with each term and condition of this Agreement when you use
                  the Application, including by providing complete and accurate registration
                  information.
                </p>
                <p className="my-2">
                  3.2 You are solely responsible for all costs arising in connection with your use
                  of the device on which you use the Application, including, without limitation,
                  costs associated with your Internet or mobile connection.
                </p>
                <p>
                  3.3 The Application may not be compatible with all devices, connection services,
                  or service plans. Not all Application features are available to all customers.
                  Availability may depend on a customer’s location, device type, service plan, and
                  other factors or restrictions.
                </p>
                <p className="my-2">
                  3.4 If you change your country-of-residence setting within the Application, you
                  will be required to accept the user agreement corresponding to your newly selected
                  country. Application features may vary by country. Risetek assumes no liability
                  for any loss incurred in connection with a change to your country setting.
                </p>
                <p>
                  3.5　We may suspend, modify, or terminate all or a portion of the Application
                  without notice or liability to you.
                </p>
              </li>
              <li>
                <h3 className="my-4 font-bold">License to Use the Application</h3>
                <p>
                  Subject to the terms of this Agreement, Risetek grants to you a nonexclusive,
                  nontransferable, revocable license to use the Application as permitted by this
                  Agreement solely for commercial use. The Application cannot be used for any other
                  purpose. You are not permitted to lease, rent, sublicense, publish, copy, modify,
                  adapt, translate, reverse engineer, decompile, or disassemble all or a portion of
                  the Application without Risetek’s prior written consent or unless otherwise
                  expressly permitted by applicable law.
                </p>
              </li>
              <li>
                <h3 className="my-4 font-bold">Digital Items</h3>
                <p>
                  5.1　By purchasing or otherwise acquiring Digital Items, you obtain a limited
                  license (as set forth in Section 4) to utilize such Digital Items within the
                  Application. Other than this limited license, you have no right or title in or to
                  Digital Items. Digital Items cannot be sold or transferred to a third party
                  (unless a transfer is permitted within the Application) and cannot be exchanged
                  for or converted to cash or legal tender or for any goods or services outside of
                  the Application.
                </p>
                <p>
                  5.2　Except as otherwise permitted by Risetek, Digital Items are not returnable or
                  refundable.
                </p>
              </li>
              <li>
                <h3 className="my-4 font-bold">Account Access</h3>
                <p>
                  Risetek may scan, access, use, monitor, delete, disclose, or preserve information
                  associated with your use of the Application (including, without limitation,
                  User-Generated Content) as is necessary, in Risetek’s discretion, (a) to comply
                  with applicable law or to respond to legal process from competent authorities; (b)
                  to enforce this Agreement or protect the rights of Risetek, its customers, or the
                  public; (c) to help prevent a loss of life or serious physical injury to anyone;
                  (d) to prevent potentially illegal or offensive activities; and (e) to provide and
                  improve features of the Application.
                </p>
              </li>
              <li>
                <h3 className="my-4 font-bold">Linked Services</h3>
                <p>
                  7.1　We are not responsible for any Third Party Services. Third Party Services are
                  not reviewed or monitored by us and may be subject to separate terms and
                  conditions. Your access and use of Third Party Services is at your own risk.
                </p>
                <p className="my-2">
                  7.2　In the event you disconnect a Linked Service, such disconnection may result
                  in the loss of rights and benefits conferred to you in connection with such Linked
                  Services, including, without limitation, rights or benefits under the Application.
                  Risetek is not responsible to you for any loss resulting from your disconnection
                  of a Linked Service.
                </p>
                <p>
                  7.3　You must comply with the terms and conditions applicable to Linked Services.
                </p>
                <p className="my-2">
                  7.4　If you link your Risetek Account to the Application, the two cannot be
                  unlinked. If your linked Risetek Account is terminated or you delete it for any
                  reason, you will lose access to all or a portion of the Application’s save data,
                  including but not limited to Digital Items.
                </p>
              </li>
              <li>
                <h3 className="my-4 font-bold">Intellectual Property Rights</h3>
                <p>
                  8.1　Except for the limited license granted to you in Section 4, Risetek retains
                  and reserves all rights, titles, and interest in and to all Risetek-owned or
                  licensed intellectual property utilized in and in connection with the Application,
                  including, without limitation, Content, registered and unregistered trademarks,
                  service marks, logos, registered and unregistered designs, copyrights, database
                  rights, inventions, patents, trade secrets, know-how, and other confidential and
                  proprietary information of Risetek, and all other proprietary or intellectual
                  property rights of any kind in any country (collectively, the “Risetek
                  Intellectual Property”).
                </p>
              </li>
              <li>
                <h3 className="my-4 font-bold">Customer Responsibility</h3>
                <p>
                  You agree to indemnify Risetek and its partners from and against any loss or
                  damage resulting from your wrongful use of the Application or any other breach of
                  this Agreement.
                </p>
              </li>
              <li>
                <h3 className="my-4 font-bold">Disclaimer of Warranties and Limitation of Liability</h3>
                <p>
                  USE OF THE APPLICATION IS AT YOUR SOLE RISK. NO ORAL OR WRITTEN INFORMATION OR
                  ADVICE GIVEN BY RISETEK OR ITS REPRESENTATIVES CREATES A WARRANTY. THE
                  APPLICATION, INCLUDING, WITHOUT LIMITATION, ALL CONTENT IS PROVIDED “AS IS”
                  WITHOUT WARRANTY OF ANY KIND, AND, TO THE FULLEST EXTENT PERMITTED BY APPLICABLE
                  LAW, RISETEK DISCLAIMS ALL WARRANTIES WITH RESPECT TO THE APPLICATION EXPRESS OR
                  IMPLIED, INCLUDING, WITHOUT LIMITATION, IMPLIED WARRANTIES OF MERCHANTABILITY AND
                  FITNESS FOR A PARTICULAR PURPOSE. TO THE MAXIMUM EXTENT PERMITTED BY LAW, RISETEK
                  WILL NOT BE LIABLE TO YOU FOR ANY SPECIAL, INDIRECT, INCIDENTAL, OR CONSEQUENTIAL
                  DAMAGES OF ANY KIND, WHETHER BASED IN CONTRACT, TORT (INCLUDING NEGLIGENCE),
                  STRICT PRODUCT LIABILITY, OR ANY OTHER LEGAL THEORY, ARISING OUT OF OR RELATING TO
                  YOUR ACCESS, USE, MISUSE, OR INABILITY TO USE THE APPLICATION, EVEN IF RISETEK HAS
                  BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IN ANY CASE, RISETEK’S AGGREGATE
                  LIABILITY TO YOU IN CONNECTION WITH ANY CLAIMS ARISING OUT OF OR RELATING TO THE
                  APPLICATION IS LIMITED TO THE AMOUNT YOU ACTUALLY PAID FOR THE APPLICATION. IF A
                  LAW RESTRICTS OUR ABILITY TO LIMIT LIABILITY OR DISCLAIM WARRANTIES, THE
                  LIMITATIONS LISTED ABOVE MAY NOT APPLY TO YOU. IN THAT CASE, WE LIMIT OUR
                  LIABILITY AND DISCLAIM WARRANTIES TO THE GREATEST EXTENT PERMITTED BY LAW.
                </p>
              </li>
              <li>
                <h3 className="my-4 font-bold">Updates to the Application</h3>
                <p>
                  You acknowledge and agree that some devices may be configured to automatically
                  receive updates. If you enable such an auto-update feature on your device, updates
                  to the Application may be automatically downloaded and installed on your device.
                  These auto-update features are not a part of our Application, so you should
                  consult with the manufacturer of your device for more information regarding these
                  features. Updates may be used to deliver features and services (including
                  software, content, and data) and may be required for you to fully enjoy all
                  features of the Application or for continued access to and use of the Application.
                  All such updates are subject to this Agreement unless other terms accompany them,
                  in which case those other terms apply.
                </p>
              </li>
              <li>
                <h3 className="my-4 font-bold">Changes to This Agreement</h3>
                <p>
                  We may update this Agreement from time to time. When we do, we will post the
                  current version in the Application. If you do not agree to such an update, you
                  must immediately stop using the Application. By continuing to access or use the
                  Application, you confirm your acceptance of the updated Agreement.
                </p>
              </li>
              <li>
                <h3 className="my-4 font-bold">Termination of This Agreement</h3>
                <p>
                  13.1　You may terminate this Agreement by uninstalling the Application from your
                  device(s). Your termination does not eliminate any obligations you have to Risetek
                  or its partners under this Agreement.
                </p>
                <p className="my-4">
                  13.2　Risetek may suspend or disable your access to all or a portion of the
                  Application or terminate this Agreement or any part of it if you fail to comply
                  with the terms and conditions of this Agreement. Upon any such termination, you
                  must immediately cease all use of the Application. Risetek may also terminate all
                  or a portion of this Agreement at any time.
                </p>
              </li>
              <li>
                <h3 className="my-4 font-bold">Assignment of Rights</h3>
                <p>
                  Except as otherwise permitted by Risetek in writing, you may not assign, lend,
                  delegate, or otherwise dispose of this Agreement or your rights hereunder without
                  Risetek’s prior written consent.
                </p>
              </li>
              <li>
                <h3 className="my-4 font-bold">Severability</h3>
                <p>
                  If any provision of this Agreement is deemed void or unenforceable, the remainder
                  of the Agreement shall remain in full force and effect.
                </p>
              </li>
              <li>
                <h3 className="my-4 font-bold">
                  Dispute Resolution; Binding Individual Arbitration; Class-Action Waiver
                </h3>
                <p>PLEASE READ THIS CAREFULLY. IT AFFECTS YOUR RIGHTS.</p>
                <p>
                  BY ENTERING INTO THIS AGREEMENT YOU AND RISETEK EXPRESSLY WAIVE THE RIGHT TO TRIAL
                  BY JURY OR TO PARTICIPATE IN A CLASS ACTION.
                </p>
                <ul>
                  <li className="my-2">
                    Please contact us using the method described in Section 18 with any questions or
                    concerns you may have regarding the Application. We can typically solve most
                    concerns to our customer’s satisfaction. Any matter we are unable to resolve and
                    all disputes or claims arising out of or relating to the Application or this
                    Agreement, including its formation, enforceability, performance, or breach
                    (each, a “Claim”), with the exception of the matters described in Section 17(c)
                    below, shall be finally settled by binding. The arbitrator’s award shall be
                    binding on the parties and may be entered as a judgment in any court of
                    competent jurisdiction. The parties understand that, absent this mandatory
                    provision, they would have the right to sue in court and have a jury trial. They
                    further understand that, in some instances, the costs of arbitration could
                    exceed the costs of litigation and the right to discovery may be more limited in
                    arbitration than in court. Any such arbitration shall be conducted by the
                    parties in their individual capacities only and not as a class action or other
                    representative action, and the parties waive their right to file a class action
                    or seek relief on a class basis. If any court or arbitrator determines that the
                    class-action waiver set forth in the preceding sentence is void or unenforceable
                    for any reason or that an arbitration can proceed on a class basis, then the
                    arbitration provision set forth in this Section shall be deemed null and void in
                    its entirety and the parties shall be deemed to have not agreed to arbitrate
                    Claims.
                  </li>
                  <li className="my-2">
                    Section 17(a) does not apply to any Claim (i) in which a party is attempting to
                    protect its intellectual property rights (such as its patent, copyright,
                    trademark, trade secret, or moral rights, but not including its privacy or
                    publicity rights) or (ii) that may be brought in small-claims court.
                  </li>
                </ul>
              </li>
              <li>
                <h3 className="my-4 font-bold">Applicable Law and Jurisdiction</h3>
                <p>
                  The laws of the state of New York, USA, without regard to its conflict of laws and
                  provisions, governs this Agreement and any dispute of any sort pertaining to this
                  Agreement or the Application that might arise between you and Risetek.
                </p>
                <p>
                  If Section 17 is held to be invalid or unenforceable, then for any Claims, the
                  parties consent to the exclusive jurisdiction of the courts located in King
                  County, Washington, USA.
                </p>
              </li>
              <li>
                <h3 className="my-4 font-bold">Contact Information</h3>
                <p>
                  If you wish to contact Risetek concerning the Application, you must fill out and
                  send the inquiry form on the Application or such other method provided by Risetek.
                </p>
              </li>
            </ol>
          </ul>
        </div>
      </div>
    </Modal>
  )
}

export default TermsModal
